import { create } from "zustand";
import { Creator } from "../../types/types";

interface DraftState {
  activeDraftCreator: Creator | null;
  isLoading: boolean;
  error: string | null;
  setActiveDraftCreator: (creator: Creator | null) => void;
  updateDraft: (
    creatorId: string,
    draftId: string,
    field: string,
    newValue: string,
    token: string | null
  ) => Promise<any>;
  reset: () => void;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const useDraftStore = create<DraftState>((set) => ({
  activeDraftCreator: null,
  isLoading: false,
  error: null,

  setActiveDraftCreator: (creator: Creator | null) =>
    set({ activeDraftCreator: creator }),

  updateDraft: async (
    creatorId: string,
    draftId: string,
    field: string,
    newValue: string,
    token: string | null
  ) => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/campaigns/updateDraft`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            creator_id: creatorId,
            draft_id: draftId,
            field,
            new_value: newValue.trim(),
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update draft");

      const data = await response.json();
      set({ isLoading: false });
      return data.data;
    } catch (error) {
      set({ error: (error as Error).message, isLoading: false });
      return null;
    }
  },

  reset: () => set({ activeDraftCreator: null, isLoading: false, error: null }),
}));
